const AUTH_REDIRECT_FLAG = '__hotwifi_auth_redirect_in_progress__';

const AUTH_STORAGE_KEYS = [
  'token',
  'accessToken',
  'refreshToken',
  'refresh_token',
  'user',
  'selectedBranch',
  'selectedTenant',
  'lastActivity',
  'sessionWarning'
];

export function clearAuthStorage() {
  AUTH_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));
}

function isAuthRedirectInProgress() {
  return typeof window !== 'undefined' && window[AUTH_REDIRECT_FLAG] === true;
}

export async function forceLogoutToLogin({ delayMs = 0, onBeforeRedirect } = {}) {
  clearAuthStorage();

  if (typeof window === 'undefined' || window.location.pathname === '/login') {
    return false;
  }

  if (isAuthRedirectInProgress()) {
    return false;
  }

  window[AUTH_REDIRECT_FLAG] = true;

  if (typeof onBeforeRedirect === 'function') {
    try {
      await onBeforeRedirect();
    } catch (error) {
      console.warn('Pre-redirect cleanup failed:', error);
    }
  }

  const redirect = () => {
    window.location.replace('/login');
  };

  if (delayMs > 0) {
    window.setTimeout(redirect, delayMs);
  } else {
    redirect();
  }

  return true;
}